export default __webpack_public_path__ + "images/loggedout/home/tweb-portrait-homepage-splashee@2x-e4c0def998526b2d2a496189e766b443.png";